import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=a0ece5da&scoped=true&"
import script from "./Image.vue?vue&type=script&lang=js&"
export * from "./Image.vue?vue&type=script&lang=js&"
import style0 from "./Image.vue?vue&type=style&index=0&id=a0ece5da&lang=scss&scoped=true&rel=stylesheet%2Fscss&"
import style1 from "./Image.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ece5da",
  null
  
)

export default component.exports